import React from 'react';
import autoBind from '../../modules/autoBind';

export default class QuickSelect extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
  }
  render() {
    const getClass = (value) => 'btn btn-default' + (this.props.value === value ? ' btn-primary active' : '') + (!this.props.editable ? ' disabled' : '');
    return (
      <div className='btn-group inline-block'>
        <For each='value' of={this.props.values}>
          <span key={value} className={getClass(value)} onKeyPress={this.handleKeyPress(value)} style={{ cursor: this.props.editable ? 'pointer' : '' }} onClick={() => this.props.editable && this.props.onChange(value)} tabIndex='0'>{value}</span>
        </For>
      </div>
    );
  }
  handleKeyPress(value) {
    return (event) => {
        if (event.keyCode === 0 || event.keyCode === 32) {
        event.preventDefault();
        this.props.onChange(value);
      }  
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/questionnaires/QuickSelect.jsx